import { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import {
  ButtonPseudo,
  // ButtonPseudo,
  ButtonSecondary,
  ButtonSize,
  // ButtonSize,
  IconDown,
  IconLoader,
  // IconTrash,
  InputText,
  Select,
  SidePanelRow,
  IconUp,
  IconLock,
  IconArrowRight,
} from '@ui/src';
import { PanelUserContentProps } from './types';
import { SignatureType } from '../../../hoc/user-list/types';

import cn from './styles.module.css';

const PanelUserContent = ({
  control,
  roleOptions,
  userInfo,
  isLoading,
  errors,
  isCreatePanel,
  isEditable,
  userId,
  // ipFields,
  onResetPassword,
  // setValue,
  // invalidIpAddressesList,
  recoveryInProgress,
  templates,
  notificationTemplatesAvailable,
  differentNotificationTemplate,
  resetToRoleInProgress,
  resetToRoleIsSuccess,
  resetNotificationTemplateInProgress,
  resetNotificationTeplateIsSuccess,
  resetNotificationTemplateToRole,
  resetNotificationTemplateToUserTemplate,
  activeLock,
  onViewLocksClick,
}: PanelUserContentProps): React.JSX.Element => {
  const [
    notificationSettingsResetCollapsed,
    setNotificationSettingsResetCollapsed,
  ] = useState(false);

  let content: React.JSX.Element;

  useEffect(() => {
    if (resetToRoleIsSuccess || resetNotificationTeplateIsSuccess) {
      setNotificationSettingsResetCollapsed(false);
    }
  }, [resetToRoleIsSuccess, resetNotificationTeplateIsSuccess]);

  if (isLoading) {
    content = (
      <div className={cn.loaderWrapper}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {activeLock && (
          <div className={cn.lockInfo}>
            <div className={cn.lockInfoLeft}>
              <div className={cn.lockInfoIcon}>
                <IconLock />
              </div>
              <div className={cn.lockInfoText}>Authorization is locked</div>
            </div>
            <div className={cn.lockInfoButtonWrapper}>
              <button
                type="button"
                className={cn.lockInfoButton}
                onClick={onViewLocksClick}
              >
                <div className={cn.lockInfoButtonContent}>View locks</div>
                <div className={cn.lockInfoButtonContent}>
                  <IconArrowRight width={12} height={12} />
                </div>
              </button>
            </div>
          </div>
        )}
        <div className={cn.blockWrapper}>
          <SidePanelRow caption="Role">
            <Controller
              control={control}
              defaultValue={userInfo?.employeeRoleTemplateId}
              name="employeeRoleTemplateId"
              render={({ field: { onChange, value, name } }) => (
                <Select
                  placeholder="Select role"
                  name={name}
                  onChange={onChange}
                  value={value}
                  list={roleOptions?.map((item) => ({
                    name: item.name,
                    value: item.value,
                  }))}
                  fullWidth
                  disabled={Boolean(userId && !isEditable)}
                  error={errors?.employeeRoleTemplateId?.message}
                  tabIndex={userId && Boolean(userId && !isEditable) ? -1 : 0}
                />
              )}
            />
          </SidePanelRow>
          {notificationTemplatesAvailable && (
            <SidePanelRow caption="Notification template">
              <>
                <Controller
                  control={control}
                  defaultValue={userInfo?.notificationTypeTemplateId}
                  name="notificationTypeTemplateId"
                  render={({ field: { onChange, value, name } }) => (
                    <Select
                      placeholder="Select notification template"
                      name={name}
                      onChange={onChange}
                      value={value}
                      list={templates?.map((item) => ({
                        name: `${item.name} ${
                          item.value === userInfo?.notificationTypeTemplateId &&
                          userInfo.isCustomNotificationsTypes
                            ? '(custom)'
                            : ''
                        }`,
                        value: item.value,
                      }))}
                      fullWidth
                      disabled={Boolean(userId && !isEditable)}
                      error={errors?.notificationTypeTemplateId?.message}
                      tabIndex={
                        userId && Boolean(userId && !isEditable) ? -1 : 0
                      }
                    />
                  )}
                />
                {userId &&
                  (differentNotificationTemplate ||
                    userInfo?.isCustomNotificationsTypes) && (
                    <div className={cn.resetCustomSettingsWrapper}>
                      <ButtonPseudo
                        text="Reset custom settings"
                        icon={
                          notificationSettingsResetCollapsed ? (
                            <IconUp />
                          ) : (
                            <IconDown />
                          )
                        }
                        onClick={() =>
                          setNotificationSettingsResetCollapsed(
                            !notificationSettingsResetCollapsed,
                          )
                        }
                        size={ButtonSize.SMALL}
                        iconPosition="right"
                      />
                      {notificationSettingsResetCollapsed && (
                        <div className={cn.resetSettingsList}>
                          {differentNotificationTemplate && (
                            <ButtonPseudo
                              text={
                                resetToRoleInProgress
                                  ? 'Loading...'
                                  : 'Reset to Role Template'
                              }
                              className={`button-white ${cn.resetSettingsButton}`}
                              onClick={resetNotificationTemplateToRole}
                            />
                          )}
                          {userInfo?.isCustomNotificationsTypes && (
                            <ButtonPseudo
                              text={
                                resetNotificationTemplateInProgress
                                  ? 'Loading...'
                                  : 'Reset to Notification Template'
                              }
                              className={`button-white ${cn.resetSettingsButton}`}
                              onClick={resetNotificationTemplateToUserTemplate}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  )}
              </>
            </SidePanelRow>
          )}
        </div>

        {/* <div className={cn.blockWrapper}>
          <SidePanelRow caption="IP whitelisting">
            <>
              <Controller
                control={control}
                name="ipsWhitelist"
                render={({ field: { onChange, name, value } }) => (
                  <div>
                    {ipFields.map((item, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div className={cn.whiteListRow} key={index}>
                        <InputText
                          placeholder="Enter IP address..."
                          name={name}
                          value={item}
                          onChange={(evt) => {
                            let nextValue = ([] as string[]).concat(
                              value as string[],
                            );

                            nextValue = nextValue.map((el, ind) => {
                              if (ind === index) {
                                return evt.target.value;
                              }
                              return el;
                            });
                            onChange(nextValue);
                          }}
                          disabled={!active || Boolean(userId && !isEditable)}
                          error={
                            errors?.ipsWhitelist?.message ||
                            invalidIpAddressesList?.find((ip) => ip === item)
                              ? 'IP address is invalid'
                              : ''
                          }
                          tabIndex={
                            !active || Boolean(userId && !isEditable) ? -1 : 0
                          }
                        />
                        {ipFields.length > 1 && (
                          <ButtonPseudo
                            className={`${cn.whiteListRemove} button-white`}
                            onClick={() => {
                              const nextList = ([] as string[]).concat(
                                value as string[],
                              );
                              nextList.splice(index, 1);

                              setValue('ipsWhitelist', nextList);
                            }}
                            icon={<IconTrash />}
                            disabled={!active || Boolean(userId && !isEditable)}
                            tabIndex={-1}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                )}
              />

              {isEditable && (
                <ButtonSecondary
                  className={cn.whiteListAdd}
                  text="+ Add IP-address"
                  size={ButtonSize.SMALL}
                  onClick={() => {
                    const nextList = ipFields ? [...ipFields, ''] : [''];
                    setValue('ipsWhitelist', nextList);
                  }}
                  disabled={!active}
                  tabIndex={-1}
                />
              )}
            </>
          </SidePanelRow>
        </div> */}
        <div className={cn.blockWrapper}>
          <SidePanelRow caption="Signature type">
            <Controller
              control={control}
              defaultValue={userInfo?.signatureType}
              name="signatureType"
              render={({ field: { onChange, value, name } }) => (
                <Select
                  placeholder="Select signature type"
                  name={name}
                  onChange={onChange}
                  value={value}
                  list={[
                    {
                      name: 'Single',
                      value: SignatureType.SINGLE,
                    },
                    {
                      name: 'None',
                      value: SignatureType.NONE,
                    },
                  ]}
                  disabled={Boolean(userId && !isEditable)}
                  error={errors?.signatureType?.message}
                  tabIndex={userId && Boolean(userId && !isEditable) ? -1 : 0}
                  fullWidth
                />
              )}
            />
          </SidePanelRow>
        </div>
        <div className={cn.blockWrapper}>
          <div className={cn.row}>
            <SidePanelRow caption="First Name">
              <Controller
                control={control}
                defaultValue={userInfo?.firstName}
                name="firstName"
                render={({ field: { onChange, value, name } }) => (
                  <InputText
                    placeholder="Enter first name..."
                    name={name}
                    value={value}
                    onChange={onChange}
                    error={errors?.firstName?.message}
                    disabled={Boolean(userId && !isEditable)}
                    tabIndex={userId && Boolean(userId && !isEditable) ? -1 : 0}
                  />
                )}
              />
            </SidePanelRow>
            <SidePanelRow caption="Last Name">
              <Controller
                control={control}
                defaultValue={userInfo?.lastName}
                name="lastName"
                render={({ field: { onChange, value, name } }) => (
                  <InputText
                    placeholder="Enter last name..."
                    name={name}
                    value={value}
                    onChange={onChange}
                    error={errors?.lastName?.message}
                    disabled={Boolean(userId && !isEditable)}
                    tabIndex={userId && Boolean(userId && !isEditable) ? -1 : 0}
                  />
                )}
              />
            </SidePanelRow>
          </div>

          <div className={cn.row}>
            <SidePanelRow caption="Email corporate">
              <Controller
                control={control}
                defaultValue={userInfo?.email}
                name="email"
                render={({ field: { onChange, value, name } }) => (
                  <InputText
                    placeholder="Enter email..."
                    name={name}
                    value={value}
                    onChange={onChange}
                    error={errors?.email?.message}
                    disabled={Boolean(userId && !isEditable)}
                    tabIndex={userId && Boolean(userId && !isEditable) ? -1 : 0}
                  />
                )}
              />
            </SidePanelRow>
            <SidePanelRow caption="Email private">
              <Controller
                control={control}
                defaultValue={userInfo?.emailPrivate}
                name="emailPrivate"
                render={({ field: { onChange, value, name } }) => (
                  <InputText
                    placeholder="Enter email..."
                    name={name}
                    value={value}
                    onChange={onChange}
                    error={errors?.emailPrivate?.message}
                    disabled={Boolean(userId && !isEditable)}
                    tabIndex={userId && Boolean(userId && !isEditable) ? -1 : 0}
                  />
                )}
              />
            </SidePanelRow>
          </div>

          {!isCreatePanel && (
            <SidePanelRow caption="ID">
              <Controller
                control={control}
                defaultValue={userInfo?.id}
                name="id"
                render={({ field: { onChange, value, name } }) => (
                  <InputText
                    placeholder=""
                    name={name}
                    value={value}
                    onChange={onChange}
                    tabIndex={-1}
                    disabled
                  />
                )}
              />
            </SidePanelRow>
          )}
        </div>

        {!isCreatePanel && onResetPassword && (
          <div>
            <ButtonSecondary
              text={recoveryInProgress ? 'Loading...' : 'Reset user password'}
              onClick={() => onResetPassword()}
              className={`${cn.resetButton} button-white button-warning`}
              tabIndex={-1}
              bold
            />
          </div>
        )}
      </>
    );
  }

  return <div className={cn.sidepanel}>{content}</div>;
};

export default PanelUserContent;
